import React from 'react'
import { stripHtml } from 'string-strip-html'

import { useSiteMetadata } from '../hooks/useSiteMetadata'

export interface SEOProps {
  title?: string
  description?: string
  pathname?: string
  children?: React.ReactNode
}

export const SEO = ({ title, description, pathname, children }: SEOProps) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    image,
    siteUrl,
  } = useSiteMetadata()
  const sanitizedDescription =
    typeof description === 'string' ? stripHtml(description!).result : ''

  const seo = {
    title: title || defaultTitle,
    description: sanitizedDescription || defaultDescription,
    image: `${siteUrl}${image}`,
    url: `${siteUrl}${pathname || ``}`,
  }

  return (
    <>
      <title>{seo.title}</title>
      <meta name="og:title" content={seo.title} />
      <meta name="og:url" content={seo.url} />
      <meta
        name="og:image"
        content={`${
          process.env.NODE_ENV === 'development'
            ? `http://localhost:8000`
            : 'https://www.toptax.cz'
        }/og-image.jpg`}
      />
      <meta name="description" content={seo.description} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      {children}
    </>
  )
}
